import React from "react";
import { Tooltip } from "antd";
import { TemplateTag } from "@/lib/types";

interface SectionTagsDisclosureProps {
  onOpenTagDocuments: (tag: TemplateTag) => void;
  sectionId: string;
  tags: TemplateTag[];
}

function SectionTagsDisclosure({
  onOpenTagDocuments,
  sectionId,
  tags,
}: SectionTagsDisclosureProps) {
  return (
    <div className="section_generator_panel_tags_disclosure" aria-labelledby={`section-tags-title-${sectionId}`}>
      <div className="section_generator_panel_tags_disclosure_header">
        <span id={`section-tags-title-${sectionId}`} className="section_generator_panel_tags_disclosure_title">
          Included tags ({tags.length})
        </span>
      </div>

      <div className="section_generator_panel_tags_scroll" aria-label="Included tags">
        {tags.length === 0 ? (
          <div className="section_generator_panel_tags_empty_state">No tags found for this section.</div>
        ) : (
          tags.map((tag) => {
            return (
              <div key={tag.id} className="section_generator_panel_tag_item">
                <Tooltip title={`${tag.name}`}>
                  <button
                    type="button"
                    className="section_generator_panel_tag_row"
                    onClick={(event) => {
                      event.stopPropagation();
                      onOpenTagDocuments(tag);
                    }}
                    style={{
                      backgroundColor: `${tag.color}08`,
                      borderColor: `${tag.color}15`,
                      color: tag.color,
                    }}
                  >
                    <span className="section_generator_panel_tag_row_content">
                      <span className="section_generator_panel_tag_row_dot" style={{ backgroundColor: tag.color }} />
                      <span className="section_generator_panel_tag_row_label">{tag.name}</span>
                    </span>
                  </button>
                </Tooltip>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default SectionTagsDisclosure;
